import React from "react";
import {
  Between,
  ButtonSmall,
  CheckValidInputs,
  Line,
  IdNumberField,
  MainCond,
  Row,
  TextField,
  ToggleGender,
  useInput,
  DateField,
  LabelSubTitle,
  Center,
  Datepicker,
} from "meitav-uikit";
import utils from "utils";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";

const { UmbracoUtills } = utils;

export default function PopUpBeneficiary(props) {
  const { resource, benefittorModel, existIdList } = props;

  const resourceStep = UmbracoStep(resource, `ThirdSub1Step`);
  const resourceError = UmbracoStep(resource, `Validation`);

  const myCond = {
    existId: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorBenefittorTaz"),
      cond: (value) => existIdList.includes(value),
    },
  };

  const firstName = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "firstName"),
    benefittorModel?.firstName || "",
    [MainCond.empty, MainCond.minLength, MainCond.hebrew]
  );
  const lastName = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "lastName"),
    benefittorModel?.lastName || "",
    [MainCond.empty, MainCond.minLength, MainCond.hebrew]
  );
  const iDNumber = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "taz"),
    benefittorModel?.taz || "",
    [MainCond.empty, MainCond.identity, myCond.existId]
  );
  const birthDate = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "birthDate"),
    benefittorModel?.birthDate || "",
    [MainCond.empty, MainCond.date]
  );
  const gender = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "genderID"),
    benefittorModel?.gender || "",
    [MainCond.empty]
  );
  const relation = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "zika"),
    benefittorModel?.relation || "",
    [MainCond.empty, MainCond.minLength, MainCond.hebrew]
  );

  const saveData = (e) => {
    if (
      !CheckValidInputs([
        firstName,
        lastName,
        iDNumber,
        birthDate,
        relation,
        gender,
      ])
    ) {
      return;
    }

    let tmpModel = benefittorModel;
    tmpModel.firstName = firstName.value;
    tmpModel.lastName = lastName.value;
    tmpModel.taz = iDNumber.value;
    tmpModel.birthDate = birthDate.value;
    tmpModel.gender = gender.value;
    tmpModel.relation = relation.value;

    props.saveBenefittorModel(tmpModel, props.benefittorIndex, props.bnfList);
  };

  return (
    <Row type="small" className="PopUpBeneficiary">
      <Center>
        <LabelSubTitle>פרטי הנהנה</LabelSubTitle>
      </Center>
      <Line gap="small">
        <TextField id="firstName" {...firstName} />
        <TextField id="lastName" {...lastName} />
      </Line>
      <Line gap="small">
        <IdNumberField id="iDNumber" {...iDNumber} />
        <Datepicker id="birthDate" {...birthDate} />
      </Line>
      <Line gap="small">
        <TextField id="relation" {...relation} />
        <ToggleGender id="gender" {...gender} />
      </Line>
      <Row type="small">
        <Between className="actions">
          <ButtonSmall
            text={UmbracoUtills.getValueByKey(resourceStep, "cancelBtn")}
            addClass="emptyColorGreen"
            onClick={() => window.popupClose()}
          />
          <ButtonSmall
            text={
              props.benefittorIndex != null
                ? UmbracoUtills.getValueByKey(resourceStep, "saveBtn")
                : UmbracoUtills.getValueByKey(resourceStep, "addBenefittor")
            }
            onClick={saveData}
          />
        </Between>
      </Row>
    </Row>
  );
}
